S.header =
    {
        config: {
            // height navbar
            offset: 29,
        },

        elements: {
            $menuIcon: null,
            $navigation: null,
            $searchIconDesktop: null,
            $searchIconMobile: null,
            $searchBarMobile: null,
            $navWrapper: null,
            $serachLayer: null,
            $close: null,
        },

        init()
        {
            this.elements.$searchIconMobile.on('click', () =>
            {
                this.searchLayerOpen();
            });


            if(sessionStorage.getItem('scrollToFooter'))
            {
                $('html, body').scrollTop($(document).height());
                sessionStorage.removeItem('scrollToFooter');
            }

            if(sessionStorage.getItem('scrollToCompetition'))
            {
                $('html, body').scrollTop($('.mod-form-competition').position().top - ($(window).height() / 4));
                sessionStorage.removeItem('scrollToCompetition');
            }

            this.menuMobile();
            this.listen();
            this.searchLayerDesktop();

            this.naviStartPosition = 0;
            this.currentPosition = $(window).scrollTop();

            $(window).on('scroll', () =>
            {
                this.checkPosition();
            });
        },

        /* set top from mobilenav by iconclick */
        startPositionMobileNav()
        {
            const navHeight = this.elements.$navigation[0].scrollHeight - this.config.offset;

            // mobile and tablet only
            if (!S.mq('desktop', false).matches)
            {
                this.elements.$navigation.css('top', -navHeight);

                setTimeout(() =>
                {
                    this.elements.$navigation.addClass('is-transition');
                }, 20);
            }
        },

        openMobileNav()
        {
            $(window).scrollTop(0);
            $('body').css('overflow', 'hidden');
            this.$module.addClass('is-mobile-nav-open');
            this.startPositionMobileNav();

            setTimeout(() =>
            {
                this.elements.$navigation.css('top', this.config.offset + 'px');
            }, 40);
        },

        closeMobileNav()
        {
            $('body').css('overflow', 'unset');
            this.$module.removeClass('is-mobile-nav-open');
            this.startPositionMobileNav();
        },

        menuMobile()
        {
            this.elements.$menuIcon.on('click', () =>
            {
                if (this.$module.hasClass('is-mobile-nav-open'))
                {
                    this.closeMobileNav();
                }
                else
                {
                    this.openMobileNav();
                }
            });
        },

        setDesktopNav()
        {
            this.elements.$navigation.css('top', 0);
        },

        listen()
        {
            S.mq('desktop').addListener((mq) =>
            {
                // S.header.closeMobileNav();
                if (mq.matches)
                {
                    if (this.$module.hasClass('is-mobile-nav-open'))
                    {
                        this.setDesktopNav();
                    }
                    else
                    {
                        this.setDesktopNav();
                    }
                }
                else if (this.$module.hasClass('is-mobile-nav-open'))
                {
                    // S.slide.openAllSlides();
                    this.elements.$navigation.css('top', this.config.offset + 'px');
                }
                else
                {
                    // S.slide.openAllSlides();
                    this.startPositionMobileNav();
                }
            });
        },

        openBgLayer()
        {
            if (S.bglayer)
            {
                S.bglayer.open();
            }
        },

        closeBgLayer()
        {
            if (S.bglayer)
            {
                S.bglayer.close();
            }
        },

        searchLayerClose()
        {
            this.elements.$searchLayer.stop().fadeOut();
            this.elements.$searchLayer.removeClass('is-active');
            this.elements.$searchBarMobile.removeClass('is-active');
            setTimeout(() =>
            {
                this.elements.$serachLayer.removeClass('is-open');
            }, 500);
            this.closeBgLayer();
        },

        searchLayerOpen()
        {
            this.elements.$searchLayer.stop().fadeIn();
            this.elements.$searchLayer.addClass('is-active');
            this.elements.$searchBarMobile.addClass('is-active');
            this.openBgLayer();
        },

        searchLayerDesktop()
        {
            this.elements.$searchIconDesktop.on('click', () =>
            {
                this.elements.$serachLayer.addClass('is-open');
                if (this.elements.$searchLayer.hasClass('is-active'))
                {
                    this.searchLayerClose();
                }
                else
                {
                    this.searchLayerOpen();
                    this.elements.$searchIconMobile.addClass('is-active');
                }
            });
        },

        checkPosition()
        {
            const windowScrollTop = $(window).scrollTop();

            this.currentPosition = windowScrollTop;
            if ((this.currentPosition >= this.naviStartPosition))
            {
                this.$module.closest('header').addClass('is-not-sticky');
            }
            else
            {
                this.$module.closest('header').removeClass('is-not-sticky');
            }

            if ($(window).scrollTop() < 50)
            {
                this.$module.closest('header').removeClass('is-not-sticky');
            }
            this.naviStartPosition = windowScrollTop;
        },

    };
